import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "p-tab",
  props: {
    selectTab: null,
    tab: null,
    tabActiveColor: {
      type: String,
      default: "#836ef9"
    },
    width: {
      type: String,
      default: "auto"
    },
    type: {
      type: String,
      default: "grid"
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  data() {
    return {};
  },
  watch: {
    selectTab: {
      handler(newTab) {
        if (!newTab) {
          this.setSelectTab(this.tab[0].value);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onTab(item) {
      this.setSelectTab(item.value);
    },
    setSelectTab(val) {
      this.$emit("update:selectTab", val);
      console.log("selectTab", this.selectTab);
    }
  },
  mounted() {
    // this.setSelectTab(this.tab[0].value);
  }
};